import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { 
  trackPageView, 
  setUserID,
  clearUserID
} from '../../utils/analytics';

export const GoogleAnalytics = () => {
  const location = useLocation();
  const { user, userProfile } = useAuth();

  useEffect(() => {
    const path = location.pathname;
    const title = document.title || 'Synesthetic.ca';

    // Track page view (always)
    trackPageView(path, title);

    // Set user ID if user is logged in
    if (user) {
      const userId = userProfile?.username || userProfile?.id || user?.uid || user?.email;
      if (userId) {
        setUserID(userId);
      }
    } else {
      // Clear user ID when user logs out
      clearUserID();
    }
  }, [location, user, userProfile]);

  return null; // This component doesn't render anything
};

